import React, { useState } from 'react';
import { Button, DialogTitle } from '@mui/material';

import { useUser } from 'queries/Users';
import { DialogAnimate } from 'components/animate';
import Form from './Form';

export default function Profile() {
  const [isOpenProfile, setIsOpenProfile] = useState(false);

  const user = useUser();

  return (
    <>
      <Button onClick={() => setIsOpenProfile(true)} sx={{ m: 0, py: 1.5, px: 2.5, width: '100%', alignItems: 'left' }}>
        My Profile
      </Button>
      <DialogAnimate open={isOpenProfile} onClose={() => setIsOpenProfile(false)} maxWidth="xs" sx={{ p: 5 }}>
        <DialogTitle sx={{ p: 0 }}>My Profile</DialogTitle>
        <Form user={user} onClose={() => setIsOpenProfile(false)} />
      </DialogAnimate>
    </>
  );
}
